import { Container as PageContainer } from './pagecontainer.css';

export default PageContainer;
